/**
 * Die Zustaende, in denen die Seite statt eines Reports eine Meldung zeigt.
 *
 * Die Werte sind zugleich der Fehlercode unten auf der Statuskarte, den der
 * Support in einer Mail wiedererkennen soll — deshalb stabil und sprechend.
 * Hier in utils und nicht bei den Komponenten, weil auch das Laden
 * (load-report.js) sie liefert, ohne etwas von React zu wissen.
 */
export const STATUS = {
  LINK_EXPIRED: "link_expired",
  APP_FAILED: "app_failed",
};
